(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rare-way-video-stories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!('IntersectionObserver' in window)) return;

    const videoSelector = '.rw-video-stories__media[data-rw-autoplay] video';
    const observed = new WeakSet();
    const autoplayObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        const video = entry.target;
        const media = video.closest('.rw-video-stories__media');

        if (!media) continue;

        if (entry.isIntersecting) {
          const sources = video.querySelectorAll('source[data-src]');

          sources.forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });

          if (sources.length > 0) video.load();
          if (media.dataset.rwAutoplay === 'true') video.play().catch(() => {});
        } else if (media.dataset.rwAutoplay === 'true') {
          video.pause();
        }
      }
    }, { rootMargin: '400px 0px' });

    const observeVideos = (root = document) => {
      if (root instanceof Element && root.matches(videoSelector) && !observed.has(root)) {
        observed.add(root);
        autoplayObserver.observe(root);
      }

      root.querySelectorAll(videoSelector).forEach((video) => {
        if (observed.has(video)) return;

        observed.add(video);
        autoplayObserver.observe(video);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeVideos(), { once: true });
    } else {
      observeVideos();
    }

    document.addEventListener('shopify:section:load', (event) => observeVideos(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
